module.exports = __webpack_public_path__ + "static/logo-1102b61c223d45a318414654c85d3583.png";